import { Typography, Box, Divider } from '@mui/material';
import { DateTime } from 'luxon';

export const EasTableInfoPannelItem = ({
	label,
	value,
	type,
	statuses,
}: {
	label: string;
	value: string;
	type: string;
	statuses?: [string, string][];
}) => {
	if (type === 'date') {
		return (
			<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
				<Typography variant="body2" color="primary">
					{label}
				</Typography>
				<Typography variant="body2" color="primary" fontWeight={600}>
					{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}
				</Typography>
			</Box>
		);
	}
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				gap: 1,
				alignItems: 'center',
			}}
		>
			<Typography variant="body2" color="primary" sx={{ fontSize: '0.8rem' }}>
				{label || ''}:
			</Typography>
			<Typography variant="body2" color="primary" fontWeight={600} sx={{ fontSize: '0.8rem' }}>
				{statuses?.find((status) => status[0] === value)?.[1] || value || '-'}
			</Typography>
		</Box>
	);
};
